module.exports = __webpack_public_path__ + "static/clem.b96286c1.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/clem.png
// module id = 168
// module chunks = 0